import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AutomationActionFailureMode } from '../types/AutomationCondition';
import styles from './AutomationConditionBuilder.module.css';

const OPTIONS: AutomationActionFailureMode[] = ['continue', 'stop', 'require_success'];

const hintKey = (value: AutomationActionFailureMode): string => {
  if (value === 'stop') {
    return 'onActionFailureStopHint';
  }
  if (value === 'require_success') {
    return 'onActionFailureRequireSuccessHint';
  }
  return 'onActionFailureContinueHint';
};

type AutomationActionFailurePickerProps = {
  value: AutomationActionFailureMode;
  disabled?: boolean;
  onChange: (value: AutomationActionFailureMode) => void;
};

export const AutomationActionFailurePicker: React.FC<AutomationActionFailurePickerProps> = ({
  value,
  disabled = false,
  onChange,
}) => {
  const { t } = useTranslation(['automations']);

  return (
    <div className={styles.builder} style={{ gap: '0.45rem' }}>
      <div className={styles.logicRow}>
        <span className={styles.field}>{t('onActionFailure')}</span>
        <div className={styles.logicTabs} role="group" aria-label={t('onActionFailure')}>
          {OPTIONS.map((option) => (
            <button
              key={option}
              type="button"
              className={`${styles.logicTab} ${value === option ? styles.logicTabActive : ''}`}
              disabled={disabled}
              onClick={() => onChange(option)}
            >
              {t(`onActionFailureModes.${option}`)}
            </button>
          ))}
        </div>
      </div>
      <p className={styles.hint}>{t(hintKey(value))}</p>
    </div>
  );
};
